/**
 * APAL Portal Storage Singleton
 * FIX-053: Cross-Portal localStorage Token Isolation
 *
 * All auth token and storage operations in the APAL portal
 * should use this singleton to ensure keys are namespaced
 * under the 'apal:' prefix.
 */

import { createPortalStorage } from '@apal/shared-utils';

export const portalStorage = createPortalStorage('apal');
